var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.5C10.9375 2.5 12.5 4.09375 12.5 6C12.5 7.9375 10.9375 9.5 9 9.5C7.0625 9.5 5.5 7.9375 5.5 6C5.5 5.71875 5.5625 5.3125 5.65625 5.03125C5.84375 5.15625 6.25 5.25 6.5 5.25C7.4375 5.25 8.25 4.46875 8.25 3.5C8.21875 3.28125 8.125 2.875 8 2.65625C8.28125 2.59375 8.71875 2.53125 9 2.5ZM17.875 5.5625C17.9375 5.6875 17.9688 5.875 17.9688 6C17.9688 6.15625 17.9375 6.34375 17.875 6.46875C16.1875 9.78125 12.8125 12 9 12C5.15625 12 1.78125 9.78125 0.09375 6.46875C0.03125 6.34375 0 6.15625 0 6.03125C0 5.875 0.03125 5.6875 0.09375 5.5625C1.78125 2.25 5.15625 0 9 0C12.8125 0 16.1875 2.25 17.875 5.5625ZM9 10.5C12.0625 10.5 14.9062 8.78125 16.4062 6C14.9062 3.21875 12.0625 1.5 9 1.5C5.90625 1.5 3.0625 3.21875 1.5625 6C3.0625 8.78125 5.90625 10.5 9 10.5Z",
    fill: "#227BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.c2cc4411df0d4706518c149a77de1deb.svg";
export { ForwardRef as ReactComponent };